'use strict';


//import 'owl-carousel';

export default class Warrant {
	constructor() {
		if( $("#warrant-stage").length > 0 ) {
			//Turn timelines into a slider

			var warrantOwl = $(".owl-carousel#warrant-stage");
			
			warrantOwl.owlCarousel({
				loop:true,
				responsiveClass:true,
				responsive:{
					 0:{
						items:2,
						nav:false
						//margin:40
					},
					600:{
						items:3,
						nav:false
						//margin: 80
					},
					1000:{
						items:5,
						nav:true,
						loop:false,
						margin:50
					}
				}
			});
		}
	}
}
